import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToCamelCase } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }, venueId) => {
  const endpoint = URLS.ratings.instructors(venueId);

  return httpClient.get(endpoint).then(({ data }) => transformKeysToCamelCase(data));
};

export default makeEntityScaffold('SAGA.API.RATINGS_INSTRUCTORS', handler, { defaultKey: 1 });
